<template lang="pug">
.b-popup(:style="{ 'z-index': zIndex }")
  ._overlay()
  ._container(@click="close")
    button._close-image(v-if="type === 'image' || type === 'video' || type === 'pdf' " @click="close")
      Icon(name="close3" pointer)
    button._nav.-prev(v-if="hasPrev" @click.prevent.stop="$emit('prev')")
      Icon(name="angle-down" pointer)
    button._nav.-next(v-if="hasNext" @click.prevent.stop="$emit('next')")
      Icon(name="angle-down" pointer)
    ._spacer(@click.stop)
      img._image(v-if="type === 'image'" :src="src" :style="`translate: ${xShift}px 0px`" :key="src")
      VuePdfEmbed._image(v-else-if="type === 'pdf'" :style="`translate: ${xShift}px 0px; width: 85vw;`" :source="`${src}?stream=1`")
      video._image(v-else-if="type === 'video'" autoplay controls controlslist="nodownload" :style="`translate: ${xShift}px 0px`" :key="src")
        source(:src="src" type="video/mp4")
      ._wrap.wrap(v-else)
        button._close(@click="close")
        ._content
          slot
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import Swipe from '@/utils/swipe';

export default {
  name: 'BasePopup',
  components: { VuePdfEmbed },
  props: {
    type: {
      type: String,
      default: 'popup',
      validator(value) {
        return ['popup', 'image', 'video', 'pdf'].indexOf(value) !== -1;
      },
    },
    zIndex: {
      type: Number,
      default: 10000,
    },
    src: String,
    hasNext: Boolean,
    hasPrev: Boolean,
  },
  data() {
    return {
      xShift: 0,
    };
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    document.addEventListener('keyup', this.onKeyUp);

    this.swipe.subscribe();
  },
  beforeDestroy() {
    document.body.style.overflow = 'visible';
    document.removeEventListener('keyup', this.onKeyUp);

    this.swipe.unsubscribe();
  },
  computed: {
    swipe() {
      return new Swipe(this.onSwipe, this.onMove);
    },
  },
  methods: {
    onSwipe(dir) {
      switch (dir) {
        case 'left': this.$emit('prev'); break;
        case 'right': this.$emit('next'); break;
        default: break;
      }
    },
    onMove(x) {
      this.xShift = x;
    },
    onKeyUp(e) {
      switch (e.key) {
        // these two lines were commented out. Why?
        case 'ArrowLeft': this.$emit('prev'); break;
        case 'ArrowRight': this.$emit('next'); break;
        default: break;
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  z-index: 10000;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10000;
    background: rgba(0, 0, 0, 0.7);
  }

  &__image {
    max-width: 90vw;
    max-height: 90vh;
    z-index: 100000;
    margin: auto;
  }

  &__container {
    z-index: 100000;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    cursor: pointer;
  }

  &__nav {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 10vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    cursor: pointer;

    svg {
      width: 100px;
      height: auto;

      &::v-deep path {
        stroke: #767676;
      }
    }

    &--next {
      right: 0;
      svg {
        transform: rotate(-90deg);
      }
    }

    &--prev {
      left: 0;
      svg {
        transform: rotate(90deg);
      }
    }
  };

  &__close-image {
    width: 10vw;
    height: 200px;
    position: absolute;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    background: transparent;
    cursor: pointer;

    svg {
      width: 30px;
      height: 30px;

      &::v-deep path {
        stroke: #767676;
      }
    }
  }

  &__spacer {
    margin: auto;
    cursor: default;
  }

  &__wrap {
    position: relative;
    padding: 32px;
    background: var(--color-white);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin: 40px 0;
    box-sizing: border-box;
    max-width: calc(100vw - 32px);
  }

  &__close {
    position: absolute;
    width: 48px;
    height: 48px;
    background: #EBEFF2;
    top: -24px;
    right: -24px;
    cursor: pointer;
    border-radius: 100%;

    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      width: 1px;
      height: 20px;
      background: #C4C4C4;
      top:14px;
      left: 23px;
    }

    &:after { transform: rotate(-45deg); }
    &:before { transform: rotate(45deg); }
  }
}
</style>
